module.exports = __webpack_public_path__ + "media/images/truck-icon-18850a656b283498b6503c0009f16f26.svg";